import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { mediaUrl } from "@/lib/api";
import StarRating from "@/components/StarRating";
import { Trophy, ArrowRight } from "@phosphor-icons/react";

const FALLBACK = "https://images.unsplash.com/photo-1607083206968-13611e3d76db?w=900&q=80";

export default function DealOfWeek({ tenant = null }) {
  const navigate = useNavigate();
  const [deal, setDeal] = useState(null);

  useEffect(() => {
    api.get("/deal-of-week", { params: tenant ? { tenant } : {} }).then((r) => setDeal(r.data)).catch(() => {});
  }, [tenant]);

  if (!deal) return null;

  return (
    <section className="max-w-7xl mx-auto px-6 pt-12" data-testid="deal-of-week">
      <div className="flex items-center gap-2 mb-4">
        <Trophy size={20} weight="fill" color="#FFD600" />
        <span className="text-xs font-black uppercase tracking-[0.25em] text-[#FFD600]">Deal of the Week</span>
      </div>
      <div
        onClick={() => navigate(`/deal/${deal.id}`)}
        className="group grid md:grid-cols-2 gap-0 border-2 border-[#FFD600] bg-[#18181B] cursor-pointer overflow-hidden hover:shadow-[8px_8px_0px_#FFD600] transition-all"
      >
        <div className="relative h-56 md:h-auto overflow-hidden">
          <img src={mediaUrl(deal.image_url) || FALLBACK} alt={deal.title}
            onError={(e) => { e.currentTarget.src = FALLBACK; }}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
          <span className="absolute top-3 left-3 bg-[#FFD600] text-black text-[10px] font-black uppercase tracking-widest px-2 py-1">★ Top Pick</span>
        </div>
        <div className="p-6 md:p-8 flex flex-col justify-center gap-3">
          <h3 className="font-display text-2xl md:text-3xl font-black uppercase leading-tight">{deal.title}</h3>
          {deal.description && <p className="text-zinc-400 line-clamp-3">{deal.description}</p>}
          <div className="flex items-center gap-4">
            <StarRating value={deal.avg_rating} count={deal.review_count} size={16} />
            {deal.price && <span className="font-mono font-extrabold text-2xl text-[#39FF14]">{deal.price}</span>}
          </div>
          <span className="mt-2 inline-flex items-center gap-2 text-sm font-black uppercase tracking-widest text-[#FF007F] group-hover:gap-3 transition-all">
            Grab this deal <ArrowRight size={18} weight="bold" />
          </span>
        </div>
      </div>
    </section>
  );
}
